import React from 'react';

export default function IntroSection({ homeData }) {
  return (
    <section class='intro-section'>
      <h2 class='section-title'>Hello, {homeData && homeData['name']}!</h2>
      <p style={{'textAlign': 'justify'}}>{homeData && homeData['intro']}</p>
    </section>
  );
}
